import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function FormatoRequisicionPersonal({ onBackToMenu }) {
  const [datosEmpleado, setDatosEmpleado] = useState({
    nombres: "",
    documento: "",
    cargo: "Cargando...",
    centroTrabajo: "",
  });

  const [formData, setFormData] = useState({
    tipoSolicitud: "AMPLIACION",
    documentoReemplazo: "",
    nombreReemplazo: "",
    cargo: "",
    puntoVenta: "",
    motivoRetiro: "AMPLIACION_PLANTA",
    motivo: "",
    perfil: "",
  });

  const [sedesLista, setSedesLista] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscando, setBuscando] = useState(false);

  useEffect(() => {
    const usuarioLocal = JSON.parse(
      localStorage.getItem("usuario") || "{}"
    );

    const token = localStorage.getItem("token");
    const API_URL = process.env.REACT_APP_API_URL;

    const fetchPerfilReal = async () => {
      try {
        const res = await fetch(
          API_URL + "/api/empleados/" + usuarioLocal.documento,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        if (res.ok) {
          const data = await res.json();

          if (data.success && data.empleado) {
            setDatosEmpleado({
              nombres: usuarioLocal.nombres || "",
              documento: usuarioLocal.documento || "",
              cargo:
                data.empleado.cargo ||
                "Sin cargo asignado",
              centroTrabajo:
                usuarioLocal.centroTrabajo || "",
            });
          }
        }
      } catch (error) {
        setDatosEmpleado({
          nombres: usuarioLocal.nombres || "",
          documento: usuarioLocal.documento || "",
          cargo:
            usuarioLocal.cargo !== "SUPER_ADMIN"
              ? usuarioLocal.cargo
              : "Administrador del Sistema",
          centroTrabajo:
            usuarioLocal.centroTrabajo || "",
        });
      }
    };

    const fetchSedes = async () => {
      try {
        const res = await fetch(
          API_URL + "/api/sedes",
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        if (res.ok) {
          const data = await res.json();

          let arregloSedes = [];

          if (Array.isArray(data)) {
            arregloSedes = data;
          } else if (
            data.sedes &&
            Array.isArray(data.sedes)
          ) {
            arregloSedes = data.sedes;
          } else if (
            data.data &&
            Array.isArray(data.data)
          ) {
            arregloSedes = data.data;
          }

          const listaActivas = arregloSedes.filter(
            (s) =>
              s.estado === "ACTIVO" ||
              s.estado === 1
          );

          setSedesLista(
            listaActivas.length > 0
              ? listaActivas
              : arregloSedes
          );
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Error al cargar sedes",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Error de red",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    };

    if (usuarioLocal.documento) {
      fetchPerfilReal();
    }

    fetchSedes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const newState = {
        ...prev,
        [name]: value,
      };

      if (
        name === "tipoSolicitud" &&
        value === "AMPLIACION"
      ) {
        newState.documentoReemplazo = "";
        newState.nombreReemplazo = "";
        newState.motivoRetiro = "AMPLIACION_PLANTA";
      } else if (
        name === "tipoSolicitud" &&
        value === "REEMPLAZO"
      ) {
        newState.motivoRetiro = "RENUNCIA"; 
      }

      return newState;
    });
  };

  const buscarEmpleadoReemplazo = async () => {
    if (!formData.documentoReemplazo) {
      return;
    }

    setBuscando(true);

    try {
      const token = localStorage.getItem("token");
      const API_URL = process.env.REACT_APP_API_URL;

      const res = await fetch(
        API_URL +
          "/api/empleados/" +
          formData.documentoReemplazo,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      if (res.ok) {
        const data = await res.json();

        if (data.success && data.empleado) {
          const empleado = data.empleado;

          const nombreConcatenado =
            empleado.nombres +
            " " +
            empleado.apellidos;

          const nombreEncontrado =
            empleado.terc_nom ||
            empleado.nombres ||
            nombreConcatenado.trim();

          setFormData((prev) => ({
            ...prev,
            nombreReemplazo: nombreEncontrado,
            cargo:
              empleado.cargo ||
              empleado.empl_cargo ||
              prev.cargo,
          }));

          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Empleado encontrado",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          throw new Error("No encontrado");
        }
      } else {
        throw new Error("Error en API");
      }
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "No Encontrado",
        text:
          "No se encontró un empleado activo con ese documento en la base de datos.",
        confirmButtonColor: "#3b82f6",
      });

      setFormData((prev) => ({
        ...prev,
        nombreReemplazo: "",
        cargo: "",
      }));
    }

    setBuscando(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.cargo ||
      !formData.puntoVenta ||
      !formData.motivo ||
      !formData.motivoRetiro
    ) {
      return Swal.fire({
        icon: "warning",
        title: "Campos Incompletos",
        text:
          "Por favor complete todos los campos obligatorios.",
        confirmButtonColor: "#3b82f6",
      });
    }

    if (
      formData.tipoSolicitud === "REEMPLAZO" &&
      !formData.nombreReemplazo
    ) {
      return Swal.fire({
        icon: "warning",
        title: "Falta Persona a Reemplazar",
        text:
          "Debe buscar y seleccionar a la persona que será reemplazada.",
        confirmButtonColor: "#3b82f6",
      });
    }

    setLoading(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");

      await fetch(
        API_URL + "/api/th/requisiciones/crear",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && {
              Authorization: "Bearer " + token,
            }),
          },
          body: JSON.stringify({
            ...datosEmpleado,
            cargoSolicitante: datosEmpleado.cargo, 
            ...formData,
          }),
        }
      );

      setTimeout(() => {
        Swal.fire({
          icon: "success",
          title: "Requisición Radicada",
          text:
            "¡Requisición de personal radicada con éxito ante Talento Humano!",
          confirmButtonColor: "#3b82f6",
        });

        setFormData({
          tipoSolicitud: "AMPLIACION",
          documentoReemplazo: "",
          nombreReemplazo: "",
          cargo: "",
          puntoVenta: "",
          motivoRetiro: "AMPLIACION_PLANTA",
          motivo: "",
          perfil: "",
        });

        setLoading(false);
      }, 1000);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error de Conexión",
        text:
          "Error de conexión con el servidor al intentar guardar.",
        confirmButtonColor: "#ef4444",
      });

      setLoading(false);
    }
  };

  // efecto Glassmorphism
  const inputClass =
    "w-full bg-white/70 backdrop-blur-sm border border-white/60 rounded-[20px] px-5 py-3.5 text-sm font-semibold text-gray-800 outline-none shadow-sm focus:ring-2 focus:ring-blue-400 focus:bg-white/95 focus:border-transparent transition-all";

  return (
    <div className="flex justify-center items-center min-h-screen p-4 sm:p-6 w-full">
      <div className="w-full max-w-4xl backdrop-blur-md bg-white/85 border border-white/50 rounded-3xl shadow-2xl p-6 sm:p-10 my-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4 border-b border-gray-200/60 pb-6">
          <div>
            <h2 className="text-3xl font-extrabold text-gray-800 tracking-tight">
              Requisición de Personal
            </h2>
            <p className="text-gray-600 mt-1 font-medium">
              Solicitante: {datosEmpleado.nombres} - {datosEmpleado.cargo}
            </p>
          </div>
          {onBackToMenu && (
            <button
              type="button"
              onClick={onBackToMenu}
              className="bg-white/80 hover:bg-white text-gray-700 border border-gray-200/80 px-5 py-2.5 rounded-[20px] font-semibold transition-all shadow-sm hover:shadow"
            >
              Volver
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-bold text-gray-700">
                Tipo de Solicitud *
              </label>
              <select
                name="tipoSolicitud"
                value={formData.tipoSolicitud}
                onChange={handleChange}
                className={inputClass}
              >
                <option value="AMPLIACION">Ampliación de Planta</option>
                <option value="REEMPLAZO">Reemplazo</option>
              </select>
            </div>

            <div className="flex flex-col">
              <label className="mb-2 text-sm font-bold text-gray-700">
                Punto de Venta / Sede *
              </label>
              <select
                name="puntoVenta"
                value={formData.puntoVenta}
                onChange={handleChange}
                className={inputClass}
              >
                <option value="">Seleccione una sede...</option>
                {sedesLista && sedesLista.map((sede, index) => (
                  <option key={index} value={sede.id || sede.nombre}>
                    {sede.nombre}
                  </option>
                ))}
              </select>
            </div>

            {formData.tipoSolicitud === "REEMPLAZO" && (
              <>
                <div className="flex flex-col md:col-span-2">
                  <label className="mb-2 text-sm font-bold text-gray-700">
                    Documento del Empleado a Reemplazar *
                  </label>
                  <div className="flex gap-4">
                    <input
                      type="text"
                      name="documentoReemplazo"
                      value={formData.documentoReemplazo}
                      onChange={handleChange}
                      className={inputClass}
                    />
                    <button
                      type="button"
                      onClick={buscarEmpleadoReemplazo}
                      disabled={buscando || !formData.documentoReemplazo}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3.5 rounded-[20px] font-semibold transition-all shadow-sm disabled:opacity-50 min-w-[120px]"
                    >
                      {buscando ? "Buscando..." : "Buscar"}
                    </button>
                  </div>
                </div>

                {formData.nombreReemplazo && (
                  <div className="flex flex-col md:col-span-2">
                    <label className="mb-2 text-sm font-bold text-gray-700">
                      Empleado a Reemplazar
                    </label>
                    <input
                      type="text"
                      value={formData.nombreReemplazo}
                      disabled
                      className={`${inputClass} bg-white/40 text-gray-500`}
                    />
                  </div>
                )}

                <div className="flex flex-col md:col-span-2">
                  <label className="mb-2 text-sm font-bold text-gray-700">
                    Motivo del Retiro *
                  </label>
                  <select
                    name="motivoRetiro"
                    value={formData.motivoRetiro}
                    onChange={handleChange}
                    className={inputClass}
                  >
                    <option value="RENUNCIA">Renuncia Voluntaria</option>
                    <option value="DESPIDO">Despido / Terminación con Justa Causa</option>
                    <option value="TERMINACION_CONTRATO">Terminación de Contrato / Obra o Labor</option>
                    <option value="PENSION">Jubilación / Pensión</option>
                    <option value="OTRO">Otro</option>
                  </select>
                </div>
              </>
            )}

            <div className="flex flex-col md:col-span-2">
              <label className="mb-2 text-sm font-bold text-gray-700">
                Cargo Solicitado *
              </label>
              <input
                type="text"
                name="cargo"
                value={formData.cargo}
                onChange={handleChange}
                className={inputClass}
              />
            </div>

            <div className="flex flex-col md:col-span-2">
              <label className="mb-2 text-sm font-bold text-gray-700">
                Perfil Requerido (Opcional)
              </label>
              <textarea
                name="perfil"
                value={formData.perfil}
                onChange={handleChange}
                rows="3"
                placeholder="Especifique habilidades, experiencia o requisitos técnicos..."
                className={`${inputClass} resize-none`}
              />
            </div>

            <div className="flex flex-col md:col-span-2">
              <label className="mb-2 text-sm font-bold text-gray-700">
                Justificación de la Solicitud *
              </label>
              <textarea
                name="motivo"
                value={formData.motivo}
                onChange={handleChange}
                rows="4"
                placeholder="Explique detalladamente el motivo de esta requisición..."
                className={`${inputClass} resize-none`}
              />
            </div>
          </div>

          <div className="mt-8 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-3.5 rounded-[20px] font-bold text-lg transition-all shadow-lg hover:shadow-xl disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? "Procesando..." : "Radicar Requisición"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}